var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"88840343565dcdf0303fd12b9bf5929971c2d2f1"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs'
import { environment } from '@/shared/consts/environment'
import { CaptureConsole } from '@sentry/integrations'

const SENTRY_DSN = environment.sentryDns || environment.sentryPublicDns
const IS_PROD = environment.env === 'production'

Sentry.init({
  dsn:
    SENTRY_DSN ||
    'https://289f52a7826e4084b59ac0ae343b86a7@o1288500.ingest.sentry.io/6540316',
  environment: environment.env,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: IS_PROD ? 0.25 : 1.0,
  // This sets the sample rate to be 75%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: IS_PROD ? 0.25 : 1.0,
  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    new CaptureConsole({
      levels: ['error'],
    }),
    new Sentry.Replay()
  ],
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
})
